import img1 from './images/set-1.png'
import img2 from './images/set-2.png'
import img3 from './images/set-3.png'
import img4 from './images/set-4.png'

export const sets = [
    {
        number: '6341',
        name: 'Gas and Go Flyer',
        img: img1,
        id: 1,
    },
    {
        number: '6515',
        name: 'Stunt Copter',
        img: img2,
        id: 2,
    },
    {
        number: '6663',
        name: 'Wave Rebel',
        img: img3,
        id: 3,
    },
    {
        number: '6594',
        name: 'Gas Transit',
        img: img4,
        id: 4,
    }
]